module.exports = __webpack_public_path__ + "img/kiwoom_main_slide2.59315fe6.png";